<nav class="mt-4">
  <div class="nav nav-tabs nav-responsive">
    <a class="nav-item nav-link" [class.active]="url === 'Dashboard-Option'" [routerLink]="['/admin/settings']" i18n>Dashboard Option</a>
    <a class="nav-item nav-link" [class.active]="url === 'Account'" [routerLink]="['/admin/settings-account']" i18n>Change password</a>
    <a class="nav-item nav-link" [class.active]="url === 'Event'" [routerLink]="['/admin/settings-event']" i18n>Event</a>
    <a class="nav-item nav-link" [class.active]="url === 'Manage-user'" [routerLink]="['/admin/settings-manage-user']" i18n>Manage Users</a>
    <a class="nav-item nav-link" [class.active]="url === 'Modules'" [routerLink]="['/admin/settings-modules']" i18n>Module</a>
  </div>
</nav>
